import { Product, SubscriptionType } from '@app/enums/_index';

import { Injectable } from '@angular/core';
import { SubscriptionTilesItem } from '@app/models/_index';
import { environment } from '@environments/environment';
import { Factory } from './_factory';

/**
 * Create Filter Home Subscription Tile Item Factory used by the home component.
 * Creates instances of Filter Subscription Tile Item
 */
@Injectable({
  providedIn: 'root',
})
export class SubscriptionTilesFactory implements Factory<SubscriptionTilesItem> {
  subscriptionTileInfo: SubscriptionTilesItem[] = [];
  subscriptionTilesNew = environment.beyond.featureFlags.subscriptionTilesNew;

  /**
   * Call and build static Filter Subscription Tile Item array.
   * Do not add or remove items from this array.
   * Used as a read-only reference.
   */
  constructor() {
    this.build();
  }

  /**
   * Build static Filter Subscription Tile Item array
   */
  build(): void {
    this.subscriptionTileInfo.push(
      new SubscriptionTilesItem(
        Product.GENESYS_CLOUD_DISPLAY_NAME,
        SubscriptionType.GENESYS_CLOUD_SUBSCRIPTION,
        'Technical Training for System Administrators, Developers and Business Users.',
        '',
        !this.subscriptionTilesNew ? 'genesys-cloud-logo.svg' : ''
      )
    );
    this.subscriptionTileInfo.push(
      new SubscriptionTilesItem(
        Product.AI_ESSENTIALS_DISPLAY_NAME,
        SubscriptionType.AI_ESSENTIAL_SUBSCRIPTION,
        'AI Capability Development for System Administrators, Developers and Business Users.',
        '',
        !this.subscriptionTilesNew ? 'beyond-cx-logo.svg' : ''
      )
    );
    this.subscriptionTileInfo.push(
      new SubscriptionTilesItem(
        Product.AGENT_PLATFORM_DISPLAY_NAME,
        SubscriptionType.AGENT_PLATFORM_SUBSCRIPTION,
        'Platform Training for Contact Center Users on Genesys Cloud.',
        '',
        !this.subscriptionTilesNew ? 'agent-platform-logo.svg' : ''
      )
    );
    this.subscriptionTileInfo.push(
      new SubscriptionTilesItem(
        Product.POINTILLIST,
        SubscriptionType.POINTILLIST_SUBSCRIPTION,
        '',
        '',
        'pointillist-logo.svg'
      )
    );
    this.subscriptionTileInfo.push(
      new SubscriptionTilesItem(
        Product.GENESYS_ENGAGE_DISPLAY_NAME,
        SubscriptionType.GENESYS_ENGAGE_SUBSCRIPTION,
        '',
        '',
        'engage-onpremises-logo.svg'
      )
    );
    this.subscriptionTileInfo.push(
      new SubscriptionTilesItem(
        Product.PURE_CONNECT,
        SubscriptionType.PURECONNECT_SUBSCRIPTION,
        '',
        '',
        'pureconnect-logo.svg'
      )
    );
  }

  /**
   * Return immutable or copy of Filter Subscription Tile Item collection
   * @returns - a slice or copy of thes static collection
   */
  getCollection(): SubscriptionTilesItem[] {
    if (this.subscriptionTileInfo && this.subscriptionTileInfo.length === 0) {
      this.build();
    }
    return this.subscriptionTileInfo.slice();
  }
}
